import '@artemis/integrations/google/import';

const runGoogleMapsFunc = callbackFn => {
  window.google.maps.importLibrary('places').then(() => callbackFn());
};

export default runGoogleMapsFunc;
